import React from 'react';
import classNames from 'classnames';

import { Icon, Segment } from 'ui';

type Color = 'gray' | 'indigo' | 'red' | 'yellow' | 'fuchsia' | 'violet' | 'green' | 'blue' | 'orange' | 'sky';

function getBgColor(color: Color | undefined) {
  switch (color) {
    case 'gray':
      return 'bg-gray-600';
    case 'indigo':
      return 'bg-indigo-600';
    case 'red':
      return 'bg-red-600';
    case 'yellow':
      return 'bg-yellow-600';
    case 'fuchsia':
      return 'bg-fuchsia-600';
    case 'violet':
      return 'bg-violet-600';
    case 'green':
      return 'bg-green-600';
    case 'blue':
      return 'bg-blue-600';
    case 'orange':
      return 'bg-orange-600';
    case 'sky':
      return 'bg-sky-600';
    default:
      return 'bg-gray-600';
  }
}

type Props = {
  icon?: UIIconName;
  color?: Color;
  feedIconRingColor?: HTMLDivElement['className'];
  feedIconOffset?: HTMLDivElement['className'];
  segmentColor?: HTMLDivElement['className'];
  renderChildren?: (children: React.ReactNode) => React.ReactNode;
  children?: React.ReactNode;
};

function FeedEvent({
  icon,
  color,
  segmentColor,
  children,
  renderChildren = () => <Segment color={segmentColor}>{children}</Segment>,
  feedIconRingColor = 'ring-gray-100',
  // Default matches Segment's py-5 header; compact cards pass a smaller offset to stay aligned.
  feedIconOffset = 'mt-7',
}: Props) {
  return (
    <li className="feed-event">
      <div className="relative pb-5">
        <span className="feed-event-line absolute top-6 left-4 -ml-px h-full w-0.5 bg-gray-200" aria-hidden="true" />
        {icon ? (
          <div className="relative flex gap-2 md:gap-6">
            <div>
              <span
                className={classNames(
                  `flex h-8 w-8 items-center justify-center rounded-full ring-8 ${feedIconRingColor} ${feedIconOffset}`,
                  getBgColor(color),
                )}
              >
                <Icon solid name={icon} color="white" fitted />
              </span>
            </div>
            <div className="min-w-0 flex-1">{renderChildren(children)}</div>
          </div>
        ) : (
          <div className="relative flex items-center gap-2 md:gap-6">
            <div>
              <div className="relative px-3">
                <div
                  className={`h-2 w-2 rounded-full bg-gray-300 ring-8 ${feedIconRingColor} flex items-center justify-center`}
                />
              </div>
            </div>
            <div className="min-w-0 flex-1 py-0">
              <div className="text-sm text-gray-500">{children}</div>
            </div>
          </div>
        )}
      </div>
    </li>
  );
}

export default FeedEvent;
